import { Setting } from '../App';
import { useState } from 'react';
import axios from 'axios';
import { CUSTOMER_API_URL } from '../constants';

const ResponseTypeDefine = {
  PARAMETERS_UNDEFINED: 'PARAMETERS_UNDEFINED',
  SAME_PRODUCT: 'SAME_PRODUCT',
  API_ERROR: 'API_ERROR',
  NONE_SUBSCRIPTION: 'NONE_SUBSCRIPTION',
  SUCCESS: 'SUCCESS',
  LOADING: 'LOADING',
} as const;
type ResponseType = typeof ResponseTypeDefine[keyof typeof ResponseTypeDefine];

export { ResponseTypeDefine };

export const useSubscriptionAdd = (setting: Setting) => {
  const [parameters, setParameters] = useState<{
    variantId: string;
    quantity: number;
    sellingPlanId: string;
    price: string;
    planPrice: string;
    btnTitle: string;
    btnClassName: string;
  }>();

  const subscriptionAdd = async (): Promise<ResponseType> => {
    if (!parameters) return ResponseTypeDefine.PARAMETERS_UNDEFINED;

    const planId = `gid://shopify/SellingPlan/${parameters.sellingPlanId}`;
    const variantId = `gid://shopify/ProductVariant/${parameters.variantId}`;
    const quantity = Number(parameters.quantity);

    try {
      const addSubscriptionResponse = await axios.post(
        `${CUSTOMER_API_URL}?action=addSubscriptionLineToFirstSubscription`,
        {
          planId,
          variantId,
          quantity,
        },
        { headers: { Authorization: setting.token } }
      );

      switch (addSubscriptionResponse.data.status) {
        case ResponseTypeDefine.NONE_SUBSCRIPTION:
          return ResponseTypeDefine.NONE_SUBSCRIPTION;
        case ResponseTypeDefine.SAME_PRODUCT:
          return ResponseTypeDefine.SAME_PRODUCT;
      }
    } catch (e) {
      return ResponseTypeDefine.API_ERROR;
    }

    return ResponseTypeDefine.SUCCESS;
  };

  return {
    parameters,
    setParameters,
    subscriptionAdd,
  };
};
